module.exports = __webpack_public_path__ + "img/zx9.b766871f.jpg";